import { Box } from '@mui/material';

const DetailsRowVolet2 = () => {
  return (
    <Box className="flex flex-col w-[max-content]">
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des progrès en matière environnementale (en particulier en matière de changement
          climatique) découlent des investissements au niveau local
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Protocoles d'accord avec la Tunisie et avec les autorités locales ; Rapports financiers
          nationaux ; Rapports maîtrise d’ouvrage ; Enquête dédiée{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          2.1.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de collectivités locales ayant adopté une stratégie climatique ou de réduction des
          risques et le mettant en œuvre avec l’appui de l’UE{' '}
          <span className="text-red-600">(? cible LoCAL: 15, Programme: 10?)</span>
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Protocoles d'accord avec la Tunisie et avec les autorités locales ; Rapports financiers
          nationaux ; Rapports maîtrise d’ouvrage ; Enquête dédiée
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Protocoles d'accord avec la Tunisie et avec les autorités locales ; Rapports financiers
          nationaux ; Rapports maîtrise d’ouvrage ; Enquête dédiée
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Les Plans d'action pour l'énergie durable et le climat (PAEDC) (ou équivalent) sont revus
          ou développés par les collectivités locales ciblées
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          2.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de Plan d'Action pour l'Energie Durable et le Climat (PAEDC) élaborés par les
          collectivités locales ciblées
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet ; rapports du Ministère de l’environnement
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet ; rapports du Ministère de l’environnement
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Un système de financement des collectivités locales est mis en place pour les
          investissements à portée environnementale et sensibles au genre.
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          2.2.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de décisions administratives adaptant le cadre réglementaire pour le financement
          des communes
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet ; rapports du Ministère de l’environnement{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet ; rapports des Ministères et des Communes{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des investissements pilotes en matière d'énergie durable et de lutte contre le changement
          climatique sont financés et réalisés dans les collectivités locales ciblées
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          2.3.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de projets d´investissement verts financés en matière d'énergie durable et de lutte
          contre le changement climatique des collectivités locales inscrits dans un PAEDC
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’opérateur ; rapports budgétaires et/ou financiers nationaux{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’opérateur ; rapports budgétaires et/ou financiers nationaux{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          La compréhension et les capacités en matière climatique et environnementales sont accrues
          dans les collectivités locales sélectionnées
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Site internet{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapport de l’opérateur{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Les PAEDC ou équivalents sont revus ou réalisées de manière participative (dans l’esprit
          de cogestion) dans les communes ciblées, intégrés dans leurs plans et budgets existants.
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapport de l’opérateur{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapport de l’opérateur{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Le système DAC est effectivement piloté (phase I) et/ou consolidé (phase II) en Tunisie et
          intègre le genre, la participation et la durabilité environnementale
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Un système de suivi – évaluation est mis en place selon les principes du mécanisme et en
          lien avec le cadre national relatif au changement climatique
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet ; rapport du Ministère de l’Environnement{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Les subventions sont octroyées aux communes et exécutées pour la réalisation d’actions
          climatiques locales.
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet ; Transactions bancaires{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          La maîtrise d'ouvrage communale est appuyée du point de vue technique, institutionnel et
          organisationnel
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de projet ; rapports d’évaluation des compétences{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
    </Box>
  );
};

export default DetailsRowVolet2;
